import styled from "styled-components";

export const CustomerCareReportContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 100px;
  row-gap: 50px;
`;
